/* @jsxImportSource react */

import { StatusChip } from '@packages/shared/src/ui/StatusChip/StatusChip';

export type BadgeDVProps = {
  text: string;
};

export const BadgeDV = ({ text }: BadgeDVProps) => (
  <StatusChip color="success" className="h-2.5 items-center uppercase">
    {text}
  </StatusChip>
);
